<template>
  <div>
    <v-card class="p-5 col-md-12">
      <div class="d-flex">
        <v-btn class="btn-send-sms" outlined @click="newCat = true">
          <span class="fa fa-plus ml-2" style="font-size: 10pt"></span>
          افزودن فروشگاه جدید
        </v-btn>

        <v-spacer />

        <span class="font-size-h6 pa-3">
          تعداد آیتم های در صف:
          {{ countList }}</span
        >
      </div>

      <div class="col-md-12 row mx-auto">
        <div class="col-md-4 col-12" v-if="smarts.length > 0">
          <v-autocomplete
            :items="smartForFilter"
            item-text="name"
            item-value="value"
            dense
            v-model="tableProps.smart_id"
            prepend-inner-icon="mdi-pencil"
            outlined
            clearable
            clear-icon="mdi-close-circle-outline"
            label="نوع"
          ></v-autocomplete>
        </div>
        <div class="col-md-4 col-12">
          <v-text-field
            dense
            v-model="tableProps.search"
            prepend-inner-icon="mdi-pencil"
            outlined
            clearable
            clear-icon="mdi-close-circle-outline"
            append-icon="fa fa-search"
            label="جستجو"
          ></v-text-field>
        </div>
        <v-col cols="12" md="6" lg="4" class="px-1">
          <v-text-field
            v-model="tableProps.mobile"
            clearable
            outlined
            dense
            label="موبایل"
            append-icon="mdi-phone"
            clear-icon="mdi-close-circle-outline"
          />
        </v-col>
      </div>

      <v-card :loading="loading">
        <div class="row mx-auto">
          <div class="col-md-6">
            <v-btn color="success" class="m-3" @click="openIt"
              >ساخت کارت ویزیت</v-btn
            >
          </div>
          <div class="col-md-6">
            <v-autocomplete
              class="col-md-3 float-end"
              :items="[10, 25, 50, 100, 200, 400]"
              v-model="tableProps.length"
              label="تعداد در صفحه"
            ></v-autocomplete>
          </div>
        </div>
        <v-simple-table class="table-striped">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  <v-checkbox @click="selectAll"></v-checkbox>
                </th>
                <th class="text-center">ردیف</th>
                <th class="text-center">شناسه</th>
                <th class="text-center">نام فروشگاه</th>
                <th class="text-center">نام دسته</th>
                <th class="text-center">تعداد آگهی</th>
                <th class="text-center">تاریخ ساخت</th>
                <th class="text-center">مدیریت</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-if="data.length > 0"
                v-for="(item, index) in data"
                :key="item.id"
                @click="selectedRow(item.id)"
                :class="
                  row === item.id ? 'bg-info font-weight-bold text-white' : ''
                "
              >
                <td class="text-center">
                  <v-checkbox v-model="selected" :value="item.id"></v-checkbox>
                </td>
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ item.id }}</td>
                <td class="text-center">{{ item.title }}</td>
                <td class="text-center">
                  {{ item.smart ? item.smart.payload.title : "-" }}
                </td>
                <td class="text-center">
                  {{ item.advertise_count }}
                </td>
                <td class="text-center">{{ item.created_at }}</td>
                <td class="text-center">
                  <v-btn
                    color="primary"
                    @click="openTab(item.site)"
                    small
                    class="mx-2"
                    >لینک فروشگاه</v-btn
                  >
                  <v-btn
                    small
                    color="success"
                    @click="
                      priceDialog = true;
                      panellID[0] = item.id;
                    "
                    >ساخت کارت ویزیت</v-btn
                  >
                </td>
              </tr>
              <tr v-if="data.length <= 0" class="text-center">
                <td></td>
                <td>
                  <p class="text-center mt-10">
                    درحال حاضر دیتایی در این جدول برای شما وجود ندارد!
                  </p>
                </td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <pagination
          v-if="pagination && data && pagination.data"
          :data="pagination"
          @page="onPagination"
        />
      </v-card>
    </v-card>
    <div>
      <custom-popup
        v-model="priceDialog"
        :cons="configs"
        max-width="700"
        id="gallery"
      >
        <v-card class="p-8">
          <model-list ref="modelslist" v-model="qrId"></model-list>

          <v-btn
            :loading="loading"
            class="mt-10 btn-send-sms"
            outlined
            @click="sendPattern"
          >
            <span class="fa fa-save ml-2" style="font-size: 10pt"></span>
            ارسال
          </v-btn>
        </v-card>
      </custom-popup>
      <custom-popup
        v-model="newCat"
        hide-confirm
        :cons="{ title: 'ایجاد دسته' }"
        max-width="700"
        id="gallery"
      >
        <v-card>
          <custom-link v-if="newCat"></custom-link>
        </v-card>
      </custom-popup>
    </div>
  </div>
</template>

<script>
import { debounce, RobotAxios } from "../../../main";
import PatternsList from "./patternsList";
import SmartList from "./smartList";
import Pagination from "@/view/content/fragments/pagination";
import ModelList from "@/view/pages/robot/modelList";
import CustomLink from "@/view/pages/robot/customLink";

export default {
  name: "pureDataList",
  components: { CustomLink, ModelList, Pagination, SmartList, PatternsList },
  data() {
    return {
      loading: false,
      priceDialog: false,
      smartList: false,
      isEditing: false,
      newCat: false,
      customLink: false,
      configs: {
        title: "ارسال هوشمند",
        buttons: [
          {
            type: "submit",
            handler: () => {
              this.sendPattern();
            },
          },
        ],
      },
      panellID: [],
      pagination: null,
      countList: 0,
      pageLength: "10",
      page: 1,
      qrID: "",
      selected: [],
      adsLink: "",
      row: "",
      title: "",
      qrId: "",
      description: {},
      smarts: [],
      modelType: "",
      type: "",
      data: {},
      qrTypes: [
        {
          text: "املاک",
          value: "real-estate-business",
        },
        {
          text: "نمایشگاه ماشین",
          value: "car-business",
        },
        {
          text: "شخصی",
          value: "personal",
        },
        {
          text: "صادرات",
          value: "expert",
        },
        {
          text: "فروشگاهی",
          value: "marketplace",
        },
        {
          text: "مشاغل",
          value: "job-business",
        },
        {
          text: "مشاور املاک",
          value: "agent-real-estate-business",
        },
        {
          text: "بنگاه ماشین",
          value: "car-concierge-business",
        },
      ],
      tableProps: {
        page: 1,
        length: 10,
        qr: 0,
        smart_id: undefined,
        search: "",
        mobile: undefined,
      },
    };
  },
  methods: {
    listCount() {
      RobotAxios.get("/api/panels/list/count")
        .then((response) => {
          this.countList = response.data.items;
        })
        .catch((reason) => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");
        });
    },
    getData(query = this.tableProps) {
      this.loading = true;
      this.row = "";

      RobotAxios.get("/api/panels?", {
        params: query,
      })
        .then((response) => {
          this.data = response.data.data.data;
          this.pagination = response.data.data;
        })
        .catch((reason) => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reseData() {
      this.description = {};
      this.type = "";
      this.modelType = "";
      this.adsLink = "";
      this.priceDialog = false;
    },
    sendPattern() {
      this.loading = true;
      RobotAxios.post("/api/panels/manual", {
        panel_id: this.panellID,
        qr_id: this.qrId,
      })
        .then(() => {
          this.loading = false;
          this.$toast.success("درخواست شما با موفقیت ثبت شد.");
          this.priceDialog = false;
          this.getData();
          this.listCount();
          this.panellID = [];
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error("خطا!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedRow(id) {
      this.row = id;
    },
    openTab(item) {
      window.open(item, "_blank");
    },
    onPagination(e) {
      if (e !== this.tableProps.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getData();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    getSmart() {
      RobotAxios.get("/api/smart/")
        .then((response) => {
          this.smarts = response.data.data;
        })
        .catch((reason) => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectAll() {
      const vm = this;
      if (vm.selected.length > 0) {
        vm.selected = [];
      } else {
        vm.selected = [];
        vm.data.forEach(function (user) {
          vm.selected.push(user.id);
        });
      }
    },
    openIt() {
      if (this.selected.length <= 0) {
        this.$toast.error("حداقل یک مورد انتخاب کنید.");
      } else {
        this.priceDialog = true;
        this.panellID = this.selected;
      }
    },
  },
  watch: {
    tableProps: {
      handler() {
        debounce(() => {
          this.tableProps.page = this.pagination.current_page;
          this.getData();
        }, 2000);
      },
      deep: true,
    },
    priceDialog() {
      this.$nextTick(() => {
        this.$refs.modelslist.$refs.searchField.focus();
        this.$refs.modelslist.tableProps.search = "";
      });
    },
  },
  created() {
    this.getSmart();
    this.getData();
  },
  mounted() {
    this.getSmart();
    this.getData();
    this.listCount();
  },
  computed: {
    smartForFilter() {
      const name = [];
      this.smarts.forEach((x) => {
        name.push({
          name: x.payload.title,
          value: x?.id,
        });
      });

      return name;
    },
  },
};
</script>

<style scoped></style>
